<template>
  <div class="navbar navbar-expand-lg">
    <AkNavigation
      v-if="!isCheckoutPage"
      ref="navigation"
      :items="items"
      :use-router-link="isRouterLink"
      @item-clicked="trackNavigation"
    >
      <template #rightSectionBanner="{ item }">
        <NavItemBanner
          v-if="item.bannerData && isEnabled('fresh-products-banner')"
          :banner-data="item.bannerData || null"
          @cta-click="closeMenu"
        />
      </template>
    </AkNavigation>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { AkNavMenuData, AkNavigation, AkNavMenuExtended } from '@ankorstore/design-system';
import { prepareDataForAkNavBar } from '@bc/discovery/domain/navigation-menu';
import { TrackingService } from '@bc/discovery/domain/tracking';
import useIsCheckout from '@core/composables/use-enclosed-checkout';
import NavItemBanner from './NavItemBanner.vue';
import { isEnabled } from '@client/monolith/legacy/services/features';

export default defineComponent({
  name: 'MainNav',
  components: {
    AkNavigation,
    NavItemBanner,
  },
  props: {
    navigationData: {
      type: Array as PropType<AkNavMenuData[]>,
      required: true,
    },
  },
  setup() {
    const { isCheckoutPage } = useIsCheckout();

    return {
      isCheckoutPage,
      isEnabled,
    };
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    isRouterLink() {
      if (!this.$router || !this.$route || !this.$route.path) {
        return false;
      }
      const currentPath = this.$route.path;
      const resolvedPath = this.$router?.resolve(currentPath);
      return resolvedPath?.matched?.length > 0 && currentPath !== '/register';
    },
  },
  async mounted() {
    this.items = prepareDataForAkNavBar(this.navigationData);
  },
  methods: {
    trackNavigation(item: AkNavMenuExtended): void {
      TrackingService.trackNavigation(item);
    },
    closeMenu(): void {
      const navigation = this.$refs.navigation as InstanceType<typeof AkNavigation> | undefined;
      if (navigation) {
        navigation.forceCloseDropdown = true;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.navbar {
  @apply ds-relative;
  z-index: 2;
}
</style>
